/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * Pellets domain - Resource collection and player progression mechanics
 * pellets.common.ts - Shared pellet utilities and helper functions
 */

import {
  PELLET_BASE_MAGNETIC_RADIUS,
  PELLET_HEALTH_GROWTH_SCALE,
  PELLET_LIFETIME,
  PELLET_MAX_WORLD_COUNT,
  PELLET_RADIUS,
  PELLET_SPAWN_COUNT_MAX,
  PELLET_SPAWN_COUNT_MIN,
  PELLET_SPAWN_RADIUS,
} from "@game/config";
import type { PelletConfig } from "./pellets.types";

// Export configuration constants for backward compatibility
export const PELLET_CONFIG: PelletConfig = {
  SPAWN_COUNT_MIN: PELLET_SPAWN_COUNT_MIN,
  SPAWN_COUNT_MAX: PELLET_SPAWN_COUNT_MAX,
  SPAWN_RADIUS: PELLET_SPAWN_RADIUS,
  LIFETIME: PELLET_LIFETIME,
  MAX_WORLD_COUNT: PELLET_MAX_WORLD_COUNT,
  BASE_MAGNETIC_RADIUS: PELLET_BASE_MAGNETIC_RADIUS,
  RADIUS: PELLET_RADIUS,
  HEALTH_GROWTH_SCALE: PELLET_HEALTH_GROWTH_SCALE,
};
